import { memo, createContext, useContext } from "react";
import { Bootcamp } from "../model/bootcamp";
import { CommonTranslates } from "../model/common-tranlates";

interface Context {
  bootcamps: Bootcamp[];
  commonTranslates: CommonTranslates;
}

const ConfigContext = createContext<Context>({
  bootcamps: [] as Bootcamp[],
  commonTranslates: {} as CommonTranslates,
});

interface BootcampContextProps {
  value: Context;
  children: React.ReactNode;
}

function BootcampContext({ value, children }: BootcampContextProps) {
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

export const BootcampProvider = memo(BootcampContext);

export function useBootcamps() {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error(`useConfig must be used within a ConfigContext.`);
  }

  return context;
}
